import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getPricesAndPolygons } from 'shared/common/thunks';
import { EPricesStatus, IPricesAndPolygonsData, IPricesAndPolygonsState } from 'shared/common/types/prices';

const initialState: IPricesAndPolygonsState = {
  status: EPricesStatus.Init,
  data: {
    prices: {
      tariffs: [],
      durations: [],
    },
    polygons: [],
  },
};

/* istanbul ignore next */
const pricesSlice = createSlice({
  extraReducers(builder) {
    builder
      .addCase(getPricesAndPolygons.pending, state => {
        state.status = EPricesStatus.Loading;
      })
      .addCase(getPricesAndPolygons.fulfilled, (state, action: PayloadAction<IPricesAndPolygonsData>) => {
        state.status = EPricesStatus.Success;
        state.data = action.payload;
      })
      .addCase(getPricesAndPolygons.rejected, state => {
        state.status = EPricesStatus.Failed;
      });
  },
  initialState,
  name: 'pricesAndPolygons',
  reducers: {},
});

export const { reducer: pricesAndPolygonsReducer } = pricesSlice;
